import { Employee, EmployeeCoreCompetenceFilter } from '../../models/employee';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, tap } from 'rxjs';
import { AbstractBackendService } from '../../prototypes/backend.service';
import { EmployeeListResult, ListResult } from '../../prototypes/list.result';
import { httpParamsFrom } from '../../utils/custom.http.param.encoder';
import { ExceptionHandlerService } from '../exceptionhandler/exception.handler.service';
import { emitSimpleEvent, SIMPLE_EVENTS } from '@core/utils/utils';

@Injectable({
  providedIn: 'root'
})
export class EmployeesCoreCompetenceService extends AbstractBackendService<Employee> {
  constructor(
    http: HttpClient,
    private exceptionService: ExceptionHandlerService
  ) {
    super(`/api/employees/`, http);
  }

  /**
   * @inheritDoc
   */
  override list(filter: EmployeeCoreCompetenceFilter, emitEvent?: boolean): Observable<ListResult<Employee>> {
    const params = httpParamsFrom(filter);
    return this.http
      .get<EmployeeListResult>(this.endPointUrl + 'search/skills/qualification', {
        params: params
      })
      .pipe(
        tap((result) => {
          result.results.forEach((employee) => {
            Reflect.deleteProperty(employee, 'debugInfos'); // unnecessary
          });
          if (emitEvent) {
            emitSimpleEvent(SIMPLE_EVENTS.DOWNLOAD_PROGRESS, { filter, result });
          }
        }),
        catchError(this.exceptionService.handleError<EmployeeListResult>())
      );
  }
}
